import { render, staticRenderFns } from "./AdminIssueEnhance.vue?vue&type=template&id=345b3a33&scoped=true&"
import script from "./AdminIssueEnhance.vue?vue&type=script&lang=js&"
export * from "./AdminIssueEnhance.vue?vue&type=script&lang=js&"
import style0 from "./AdminIssueEnhance.vue?vue&type=style&index=0&id=345b3a33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345b3a33",
  null
  
)

export default component.exports